export default __webpack_public_path__ + "2fa53bc942f60e23ed464d665816a032.png";